/**
 * Single source of truth for responsive breakpoints.
 *
 * Every hook, shell and layout decision in the app should read these values
 * instead of hardcoding pixel widths, so that no two components can disagree
 * about whether the viewport is "mobile".
 */

export const BREAKPOINTS = {
  /** < 768px — phones */
  mobile: 768,
  /** 768–1023px — tablets */
  tablet: 1024,
  /** >= 1024px — desktop */
  desktop: 1280,
} as const;

export type Breakpoint = "mobile" | "tablet" | "desktop";

export function resolveBreakpoint(width: number): Breakpoint {
  if (width < BREAKPOINTS.mobile) return "mobile";
  if (width < BREAKPOINTS.tablet) return "tablet";
  return "desktop";
}

/** Media query string matching phone-sized viewports. */
export const MOBILE_QUERY = `(max-width: ${BREAKPOINTS.mobile - 1}px)`;

/** Media query string matching phone + tablet viewports (compact shell). */
export const COMPACT_QUERY = `(max-width: ${BREAKPOINTS.tablet - 1}px)`;
